export default __webpack_public_path__ + "static/media/hemorragia_digestiva_baja.4cc7c7c1.pdf";